(function () {

    'use strict';

    angular.module('iplusjs.tooltip.info', [
        'mm.foundation.mediaQueries',
        'mm.foundation.position',
        'mm.foundation.transition',
        'mm.foundation.dropdownToggle',
        'lodash',
        'iplusjs.integration',
        'angulartics'
    ])
    .component('iplusjsTooltipInfo', {
        restrict: 'AE',
        bindings: {
            name: '@itiName'
        },
        templateUrl: 'common/tooltip/tooltipInfo.html',
        controller: TooltipInfoController,
        controllerAs: 'tooltipInfoVm'
    });

    TooltipInfoController.$inject = [
        '$rootScope',
        'lodash',
        'IntegrationService',
        '$analytics'
    ];
    function TooltipInfoController($rootScope, _, IntegrationService, $analytics) {
        var vm = this,
            actualHeightValue = 0;

        vm.$onInit = onInit;

        vm.onOpenDropdown = onOpenDropdown;
        vm.onCloseDropdown = onCloseDropdown;

        function onInit() {
            if (_.isNil(vm.name)) {
                throw 'itiName attribute is missing!';
            }

            vm.id = 'dt-' + vm.name;
        }

        function onOpenDropdown() {
            actualHeightValue = IntegrationService.getActualHeight();
            IntegrationService.addHeightValue(actualHeightValue, 'dropdownToggle');
            $analytics.eventTrack('info', {
                trackingProvider: 'wgv',
                target: vm.name
            });

            $rootScope.$emit('iplusjs:heightChanged');
        }

        function onCloseDropdown() {
            IntegrationService.clearMaxHeight('dropdownToggle');
            actualHeightValue = 0;

            $rootScope.$emit('iplusjs:heightChanged');
        }
    }
})();
